import RecordEvent from './RecordEvent'
import TRecordPCEvent from './TRecordPCEvent'
import createGoogleAnalytics from './agents/googleAnalytics'

const recordPCEvent = new RecordEvent<TRecordPCEvent>()
recordPCEvent.addAgent(createGoogleAnalytics<TRecordPCEvent>())
export default recordPCEvent
